module.exports = __webpack_public_path__ + "static/10-b4872a77e7c3cdb188a862bb04d49606.jpeg";